import { defineComponent, h } from "vue";
import { RouterLink } from "vue-router";
import { isExternalLink } from "@/utils/core";

export const LinkNode = defineComponent({
  name: "LinkNode",
  props: {
    path: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  setup(props) {
    const linkNode = isExternalLink(props.path as string)
      ? h("a", { href: props.path, target: "_blank" })
      : h(RouterLink as any, { to: props.path });
    return () => {
      return linkNode;
    };
  },
});
